<template>
  <div class="card">
    <span class="title">{{ cancel.title }}</span>
    <span class="sub-title">ยกเลิกเมื่อ {{ updatedAt }}</span>
    <div class="data-container _mgt-8">
      <div class="header">ระยะเวลา :</div>
        <div class="line-container">
        <div class="detail" v-for="(time, index) in cancel.periodCancel" :key="time+index">{{ time }}</div>
      </div>
    </div>
    <div class="data-container _mgt-8">
      <div class="header">สาเหตุ :</div>
      <div class="detail">{{ cancel.reason }}</div>
    </div>
    <div class="data-container _mgt-8" v-if="cancel.reasonDetail !== ''">
      <div class="header">รายละเอียด :</div>
      <div class="detail">{{ cancel.reasonDetail }}</div>
    </div>
    <div class="data-container _mgt-8" v-if="cancel.refund">
      <div class="header light">{{ cancel.refundLabel }} :</div>
      <div class="detail light">{{ cancel.priceRefundTotal }}</div>
    </div>
    <div class="data-container _mgt-8" v-if="cancel.refund">
      <div class="header light">{{ cancel.priceRefundChargePercent }} :</div>
      <div class="detail light">{{ cancel.priceRefundCharge }}</div>
    </div>
    <div class="data-container _mgt-8" v-if="cancel.refund">
      <div class="header light">{{ cancel.priceRefundVatPercent }} :</div>
      <div class="detail light">{{ cancel.priceRefundVat }}</div>
    </div>
    <div class="data-container _mgt-8" v-if="cancel.refund">
      <div class="header light">ราคาสุทธิที่ต้องคืน ({{ cancel.shiftCancel }}) :</div>
      <div class="detail light">{{ cancel.priceRefundNet }}</div>
    </div>
  </div>
</template>

<style lang="scss">
</style>

<style lang="scss" scoped>
  .card {
    background: #FFFFFF;
    padding: 48px 56px;
    display: flex;
    flex-direction: column;
    min-height: 330px;

    .title {
      font-family: 'Sukhumvit-Bold';
      line-height: 25px;
      font-size: 22px;
      color: #434B61;
    }

    .sub-title {
      margin-top: 4px;
      font-family: 'Sukhumvit-Medium';
      line-height: 19px;
      font-size: 12px;
      color: #A2A7B3;
      margin-bottom: 16px;
    }

    .data-container {
      display: flex;
      flex-direction: row;

      .header {
        flex: 1;
        font-family: 'Sukhumvit-Bold';
        font-size: 14px;
        line-height: 20px;
        color: #434B61;
        font-weight: 600;
      }

      .detail {
        flex: 1;
        font-family: 'Sukhumvit-Medium';
        font-size: 14px;
        line-height: 20px;
        color: #434B61;
      }

      .line-container {
        display: flex;
        flex-direction: column;
        flex: 1;
      }

      .light {
        color: #A2A7B2 !important;
      }

      &._mgt-8 {
        margin-top: 8px;
      }
    }
  }
</style>

<script>
import moment from 'moment'

export default {
  name: 'Sectionjob',
  data () {
    return {
    }
  },
  props: {
    cancel: {
      type: Object,
      required: true,
    },
  },
  computed: {
    updatedAt () {
      return moment(this.cancel.updatedAt).format('DD/MM/YYYY, HH:mm')
    },
  },
  methods: {
  },
}
</script>
